import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, tap } from 'rxjs/operators';

import { ComponentAbstract } from '@app/components/abstract/component.abstract';
import { UserData } from '@shared/interfaces/user-data';
import { selectUserData } from '@shared/selectors/user.selectors';

@UntilDestroy()
@Component({
  selector: 'app-empty-dashboard',
  templateUrl: './empty-dashboard.component.html',
  styleUrls: ['./empty-dashboard.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmptyDashboardComponent extends ComponentAbstract implements OnInit, OnDestroy {
  userData: UserData;
  userData$: Observable<UserData>;

  constructor(protected cdr: ChangeDetectorRef, private store: Store<{}>) {
    super(cdr);
  }

  ngOnInit(): void {
    this.userData$ = this.store.select(selectUserData);
    this.userData$
      .pipe(
        untilDestroyed(this),
        filter((userData: UserData) => !!userData),
        tap((userData: UserData) => {
          this.userData = userData;
        })
      )
      .subscribe();
  }

  ngOnDestroy(): void {}
}
